import { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Button } from 'shared/ui/Button';

import { useHolidaysActions, useHolidaysIsWarningValue } from './store/store';

export function WarningAlert() {
  const isOpen = useHolidaysIsWarningValue();
  const { setIsWarning } = useHolidaysActions();

  const handleAccept = () => {
    setIsWarning(false);
  };

  return (
    <Transition
      appear
      show={isOpen}
      as={Fragment}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div
          className={classNames(
            'z-10 mb-10 h-[186px] w-[340px] overflow-hidden rounded-md border border-orange-100 bg-white pt-2 pl-4 pr-3 text-left align-middle transition-all fixed bottom-23 right-1 left-0 mx-auto'
          )}
        >
          <div className="flex gap-4">
            <MaterialIcon className="h-[24px] w-[24px] pt-2 text-orange-500">warning_amber</MaterialIcon>
            <div>
              <div className="mt-2">
                <p className="text-sm font-normal text-slate-700">
                  Some dates cannot be added or removed because it is two weeks or less before the event or it's a date
                  that's already passed. Please contact your partnerships manager.
                </p>
              </div>
              <div className="mt-[17px]">
                <Button
                  type="button"
                  size="medium"
                  className="bg-blue-100 text-blue-900 hover:bg-blue-200 focus-visible:ring-blue-500 inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                  onClick={handleAccept}
                >
                  Got it
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}
